import { Icon } from '@iconify/react';
import classnames from "classnames";
import Styles from "../../../../components/comingSoon/styles.module.scss";
import ellowLogo from "../../../../assets/images/ellow-logo.svg";
import pageGraphics from "../../../../assets/images/comingsoon.svg";


function Help() {



  return (
    <section className={Styles.errorWrap}>
      <img src={ellowLogo} alt="Ellow" className={Styles.logo} />
      <div className={Styles.errorMessage}>
        <img src={pageGraphics} alt='pageGraphics'/>
        {/* <h1>Coming Soon!</h1> */}
        <h3>For any queries /concerns please reach out to <a style={{'color':'#14A800'}} href="mailto:team@ellow.io">team@ellow.io</a> </h3>
      </div>
    </section>
  )
}


export default Help